module.exports = __webpack_public_path__ + "img/yj_share_guide2.e3fab1de.png";